export default [
  {
    path: '',
    name: 'apps-user-list',
    component: () => import(/* webpackChunkName: "apps-user-list" */ '@/apps/user/pages/UserListPage.vue'),
    meta: {
      layout: 'content',
    },
  },
]
